import React, { memo } from 'react'

import type { CarouselTitleProps } from './types'

const CarouselTitle = ({ isLive, title }: CarouselTitleProps) => {
  return (
    <h2 className="carousel__title">
      {isLive ? (
        <>
          <div className="carousel__title--live-icon" />
          {title}
        </>
      ) : (
        title
      )}
    </h2>
  )
}

export default memo(CarouselTitle)
